import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { sendEmailMessage } from '../api/Email';
import { setSuccess } from '../actions/notifications';

const useContactSubmit = () => {
  const dispatch = useDispatch();

  return useCallback(
    async (data) => {
      try {
        const { firstName, lastName } = data;
        await sendEmailMessage({
          from: data.email,
          subject: 'Contact Form Enquiry',
          type: 'contact-notification',
          preview: `${firstName} ${lastName} would like to sign up to the system.`,
          data,
        });
      } catch (error) {
        console.log(error);
      }

      dispatch(setSuccess(`Thank you for your message. We will get in touch as soon as possible.`));
    },
    [dispatch],
  );
};
export default useContactSubmit;
